import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'


import AttachedFilesBox from '../Shared/AttachedFilesBox'
import BoxSection from '../Layout/BoxSection'
import ModalAddFile from '../Shared/ModalAddFile'
import BoxButton from '../Layout/BoxButton'


import {
    isAllowedToViewComponent,
    formatcoin,
    getDivisa
} from '../../utils/helpers'




import {
    addFile,
    removeFiles,
    updateInputs,
    getDocumento,
} from '../../actions/documentos'

import {
    getSolicitud
} from '../../actions/solicitudservicioot'

function getClassDetalle(detalle) {
    if (detalle.get('adicion_id')) {
        return 'adicional'
    } else if (detalle.get('tipo') === 4) {
        return 'otrosi'
    } else {
        return ''
    }
}



class General extends Component {
    

    estaCotizado = () => {
        return this.props.documento.getIn(['cotizacion', 'cotizado']) != 0
    }

    
	render() {
        
        const { documento, enums, documento_origen, summary, divisas } = this.props
        if (!documento) return null
        if (!documento.get('detalles')) return null

        const moneda = documento.getIn(['cotizacion', 'moneda']);
        const divisa = getDivisa(divisas, moneda)

        const totalSevicios = documento.get('detalles').reduce((a, b) => {
            if (!b.get('adicion_id')) a += (b.get('valor') * b.get('cantidad')) 
            return a
        }, 0)

        const editar = summary.get('editar')
        const solicitud = documento.get('solicitude')
        const soloResponsableCompras = isAllowedToViewComponent('responsable_compras', solicitud)  
        const id = documento.get('id')

        let accionesDetalles = []
        if (soloResponsableCompras) {
            // accionesDetalles = [
            //     <BoxButton key="ba[0][0]" size={14} contrast name="pencil" onClick={ () => this.props.updateInputs('modalSummary.editar', !editar) } title="Editar costos" active={ editar }  />,
            // ]
        }

		return (
            <div>
                <BoxSection title="Información básica">

                
                    <div className="row">

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Tipo de documento</label>
                                <input type="text" value={ enums.documentos.tipos[documento.get('tipo')].NOMBRE } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Número</label>
                                <input type="text" value={ documento.get('consecutivo') } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        {

                            (documento.get('tipo') == 4) ? (

                                <div className="col-md-2 col-md-offset-7">
                                    <div className="form-group">
                                        <label className="control-label">Orden/Contrato</label>
                                        <input type="text" value={ `${enums.documentos.tipos[documento_origen.get('tipo')].PREFIJO}${documento_origen.get('consecutivo')}` || '' } className="form-control input-sm" disabled/>
                                    </div>
                                </div>

                            ) : (

                                <div className="col-md-2 col-md-offset-7">
                                    <div className="form-group">
                                        <label className="control-label">No. Solicitud</label>
                                        <input type="text" value={ documento.getIn(['solicitude', 'id']) } className="form-control input-sm" disabled/>
                                    </div>
                                </div>
                            )

                        }

                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Proveedor</label>
                                <input type="text" value={ documento.getIn(['proveedore','nombre']) } className="form-control input-sm" disabled/>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha de inicio (creación)</label>
                                <input type="text" value={ moment(documento.get('fecha_inicio')).format('YYYY-MM-DD') } className="form-control input-sm" disabled/>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha de entrega</label>
                                <input type="text" value={ moment(documento.get('fecha_entrega')).format('YYYY-MM-DD') } className="form-control input-sm" disabled/>
                            </div>
                        </div>


                        <div className="col-md-1">
                            <div className="form-group">
                                <label className="control-label">Anticipo</label>
                                <input type="text" value={ totalSevicios > 0 ? numeral(documento.get('anticipo') / 100).format('0.0%') : '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Valor anticipo</label>                                                                
                                <input type="text" value={ totalSevicios > 0 ? formatcoin((totalSevicios * documento.get('anticipo') / 100),divisa.simbolo) : '' } className="form-control input-sm" disabled/>                                
                            </div>
                        </div>



                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha pago anticipo</label>
                                <input type="text" value={ totalSevicios > 0 ? documento.get('pago_anticipo') ? moment(documento.get('pago_anticipo')).format('YYYY-MM-DD') : '' : '' } className="form-control input-sm" disabled/>
                            </div>
                        </div>

                        
                    </div>
                    <div className="row">
                        {
                            (documento.get('garantias').count() > 0 && 
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="control-label">Garantias</label>
                                        <div style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>
                                            <div className="row">
                                            {
                                                documento.get('garantias').map((a, b) => {
                                                    return (
                                                        <div key={ `div1[${a.get('id')}]` } className="col-md-6">
                                                            <div className="checkbox" style={{ margin: '0' }}>
                                                                <label>
                                                                    <input type="checkbox" checked={ true } disabled />
                                                                    { a.get('nombre') }
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }


                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="control-label">Opciones adicionales</label>
                                <div style={{ padding: '5px 10px', border: '1px solid #eee', borderRadius: '3px' }}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="checkbox" style={{ margin: '0' }}>
                                                <label>
                                                    <input type="checkbox" checked={ documento.get('entregas_parciales') } disabled />
                                                    Entregas parciales
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="checkbox" style={{ margin: '0' }}>
                                                <label>
                                                    <input type="checkbox" checked={ documento.get('validacion_soma') } disabled />
                                                    Validación por SOMA
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </BoxSection>


                <div className="separator" />


                <BoxSection title="Detalle" actions={ accionesDetalles }>


                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-solicitudes">
                        <thead>
                            <tr>
                                <th style={{ width: '5%' }}>No.</th>
                                <th style={{ width: '40%' }}>Item</th>
                                {
                                    editar ? (
                                        <Fragment>
                                        <th style={{ width: '10%' }}>Valor unt. sin IVA</th>
                                        <th style={{ width: '10%' }}>Valor unt. con IVA</th>
                                        </Fragment>
                                    ):(
                                        <Fragment>
                                        <th style={{ width: '10%' }}>Valor sin IVA</th>
                                        <th style={{ width: '10%' }}>Valor total</th>
                                        </Fragment>
                                    )
                                }
                                <th style={{ width: '35%' }}>Distribución</th>
                            </tr>
                        </thead>
                        <tbody>
                            {                                
                                (documento.get('todos_detalles').count() > 0) &&
                                    documento.get('todos_detalles').map((x, n) => {
                                        return (
                                            <tr key={ x.get('id') }>
                                                <td style={{ textAlign: 'right' }} className={ getClassDetalle(x) }>{ n + 1 }</td>
                                                <td>{ x.get('descripcion') } {x.get('tipo') == 4 ? `<Solicitud No. ${x.get('solicitud_id')}>` : null}</td>
                                                {
                                                    editar ? (
                                                        <Fragment>
                                                        <td style={{ textAlign: 'right' }}><input type="number" value={  x.get('valor')  || '' } className="form-control input-sm" onChange={ (e) => this.props.updateInputs(`modalSummary.data.todos_detalles.${n}.valor`, e.target.value, id) } /></td>
                                                        <td style={{ textAlign: 'right' }}><input type="number" value={  x.get('valor_con_iva')  || '' } className="form-control input-sm" onChange={ (e) => this.props.updateInputs(`modalSummary.data.todos_detalles.${n}.valor_con_iva`, e.target.value, id) } /></td>
                                                        </Fragment>
                                                    ):(
                                                        <Fragment>
                                                        <td style={{ textAlign: 'right' }}>{ formatcoin((x.get('valor') * x.get('cantidad')),divisa.simbolo) }</td>
                                                        <td style={{ textAlign: 'right' }}>{ formatcoin((x.get('valor_con_iva') * x.get('cantidad')),divisa.simbolo) }</td>
                                                        </Fragment>
                                                    )
                                                }
                                                <td style={{ padding: 0 }}>
                                                    <table className="table table-bordered table-condensed nowrap">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '20%' }}>Cenco</th>
                                                                <th style={{ width: '36%' }}>Ordenador</th>
                                                                <th style={{ width: '22%' }}>Porcentaje</th>
                                                                <th style={{ width: '22%' }}>Valor</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                x.get('cencos').map((e, f) => {
                                                                    return (
                                                                        <tr key={ `tr2[${x.get('id')}][${e.get('id')}]` }>
                                                                            <td><span title={ `${e.get('descripcion')}` }>{ e.get('codigo') }</span></td>
                                                                            <td>{ `${e.get('nombres')} ${e.get('apellidos')}` }</td>
                                                                            <td style={{ textAlign: 'right' }}>{ numeral(e.get('porcentaje') / 100).format('0.0%') }</td>
                                                                            <td style={{ textAlign: 'right' }}>{ formatcoin(((e.get('porcentaje') / 100) * x.get('valor_con_iva') * x.get('cantidad')),divisa.simbolo) }</td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>

                                                </td>
                                            </tr>
                                        )
                                    })
            
                            }

                            {
                                (documento.get('detalles').count() == 0) && (
                                    <tr>
                                        <td colSpan={ 5 } style={{ textAlign: 'center' }}>Ha ocurrido un error</td>
                                    </tr>
                                )
                            }




                        </tbody>
                    </table>
                </BoxSection>
                <div className="separator"></div>
                <AttachedFilesBox
                    files={ documento.get('adjuntos') }
                    root='modalSummary.data'
                    removeFiles = { this.props.removeFiles }
                    updateInputs = { this.props.updateInputs }
                    obj={ documento }
                    check={ 'documento' }
                    disabledAttach={this.props.disabledAttach}
                />
                <ModalAddFile
                    action={ () => this.props.addFile(`/files/${documento.get('solicitud_id')}`, documento.get('id'), [() => this.props.getDocumento(documento.get('id')), () => this.props.getSolicitud(documento.get('solicitud_id'))]) }
                />




            </div>
		)
	}
}


function mapStateToProps(state, ownProps) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        documento_origen: ownProps.reducer ? state[ownProps.reducer].getIn(['solicitud', 'documento_origen']) : null,
        enums: state.common.get('enums').toJS(),
        summary: state.documentos.get('modalSummary'),
        divisas: state.common.getIn(['parametros', 'DIVISAS'])
    }
}


function mapDispatchToProps(dispatch) {
    return {
        addFile: (url, documentoId, actions) => dispatch(addFile(url, documentoId, actions)),
        removeFiles: () => dispatch(removeFiles()),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        getDocumento: (id) => dispatch(getDocumento(id)),
        getSolicitud: (id) => dispatch(getSolicitud(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(General)


// WEBPACK FOOTER //
// ./src/components/Documentos/General.jsx